import { gql } from '@apollo/client'

export const SUBMIT_CLASSIFICATION_CORRECTION = gql`
  mutation SubmitClassificationCorrection(
    $input: SubmitClassificationCorrectionInput!
  ) {
    submitClassificationCorrection(input: $input) {
      __typename
      ... on SubmitClassificationCorrectionResult {
        success
        boundingBox {
          id
          verifiedUpc
          leasedById
          leasedAt
        }
      }
      ... on OperationInfo {
        messages {
          kind
          message
          field
          code
        }
      }
    }
  }
`
